class ProductMediaBlackFriday {
  constructor() {
    this.container = document.querySelector('[data-product-media-black-friday]');
    if (!this.container) return;

    this.slider = this.container.querySelector('[data-product-media-slider]');
    this.thumbnails = this.container.querySelectorAll('[data-thumbnail]');
    this.thumbnailsContainer = this.container.querySelector('[data-thumbnails]');
    this.scrollIndicator = this.container.querySelector('[data-scroll-indicator]');
    this.swiperInstance = null;

    this.init();
  }

  init() {
    this.bindThumbnailClicks();
    this.bindVariantChange();
    this.initScrollIndicator();
    
    this.waitForSwiper();
  }

  waitForSwiper() {
    const checkSwiper = setInterval(() => {
      if (this.slider && this.slider.swiper) {
        this.swiperInstance = this.slider.swiper;
        clearInterval(checkSwiper);
      }
    }, 100);

    setTimeout(() => clearInterval(checkSwiper), 5000);
  }

  bindThumbnailClicks() {
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();
        
        this.thumbnails.forEach(t => t.classList.remove('active'));
        thumbnail.classList.add('active');

        if (this.swiperInstance) {
          this.swiperInstance.slideTo(index);
        }

        this.scrollThumbnailIntoView(thumbnail);
      });
    });
  }

  scrollThumbnailIntoView(thumbnail) {
    if (!this.thumbnailsContainer) return;

    const containerRect = this.thumbnailsContainer.getBoundingClientRect();
    const thumbnailRect = thumbnail.getBoundingClientRect();

    if (thumbnailRect.top < containerRect.top || thumbnailRect.bottom > containerRect.bottom) {
      thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  initScrollIndicator() {
    if (!this.scrollIndicator || !this.thumbnailsContainer) return;

    const checkScroll = () => {
      const isScrollable = this.thumbnailsContainer.scrollHeight > this.thumbnailsContainer.clientHeight;
      const isAtBottom = this.thumbnailsContainer.scrollHeight - this.thumbnailsContainer.scrollTop <= this.thumbnailsContainer.clientHeight + 10;

      if (!isScrollable || isAtBottom) {
        this.scrollIndicator.style.opacity = '0';
      } else {
        this.scrollIndicator.style.opacity = '1';
      }
    };

    checkScroll();
    this.thumbnailsContainer.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    this.scrollIndicator.addEventListener('click', () => {
      this.thumbnailsContainer.scrollBy({
        top: 200,
        behavior: 'smooth'
      });
    });
  }

  bindVariantChange() {
    document.addEventListener('variant:change', (event) => {
      const variantId = event.detail?.variant?.id;
      if (!variantId) return;

      this.handleVariantChange(variantId);
    });
  }

  async handleVariantChange(variantId) {
    const variantImagesData = document.getElementById('variant-images-data-black-friday');
    if (!variantImagesData) return;

    let variantImages;
    try {
      variantImages = JSON.parse(variantImagesData.textContent);
    } catch (e) {
      return;
    }

    variantId = String(variantId);
    const variantImgs = variantImages[variantId];

    if (variantImgs && variantImgs.length > 0) {
      await this.showVariantImages(variantId, variantImgs);
    } else {
      this.showDefaultImages(variantId);
    }
  }

  async showVariantImages(variantId, images) {
    if (!this.slider) return;

    const slides = this.slider.querySelectorAll('[data-variant-media]');
    const defaultSlides = this.slider.querySelectorAll('[data-default-media]');

    defaultSlides.forEach(slide => {
      slide.style.display = 'none';
    });

    const currentVariantSlides = Array.from(slides).filter(
      (slide) => slide.getAttribute('data-variant-id') === String(variantId)
    );

    if (currentVariantSlides.length > 0) {
      slides.forEach(slide => {
        if (slide.dataset.variantId === String(variantId)) {
          slide.style.display = '';
        } else {
          slide.style.display = 'none';
        }
      });

      const firstSlideIndex = Array.from(this.swiperInstance.slides).indexOf(currentVariantSlides[0]);
      if (firstSlideIndex !== -1) {
        this.swiperInstance.slideTo(firstSlideIndex, 0);
      }
    } else {
      slides.forEach(slide => {
        if (slide.getAttribute('data-variant-id') !== String(variantId)) {
          const slideIndex = Array.from(this.swiperInstance.slides).indexOf(slide);
          if (slideIndex !== -1) {
            this.swiperInstance.removeSlide(slideIndex);
          }
        }
      });

      const newSlides = [];
      const newThumbnails = [];

      images.forEach((image, index) => {
        const slide = document.createElement('div');
        slide.className = 'product-media-black-friday--slide swiper-slide loading';
        slide.setAttribute('data-index', index);
        slide.setAttribute('data-variant-media', 'true');
        slide.setAttribute('data-variant-id', variantId);

        const figure = document.createElement('figure');
        const placeholder = document.createElement('div');
        placeholder.className = 'product-media-placeholder';
        figure.appendChild(placeholder);
        slide.appendChild(figure);
        newSlides.push(slide);

        const thumbnail = document.createElement('button');
        thumbnail.type = 'button';
        thumbnail.className = 'product-media-black-friday--thumbnail';
        if (index === 0) thumbnail.classList.add('active');
        thumbnail.setAttribute('data-thumbnail', '');
        thumbnail.setAttribute('data-index', index);
        thumbnail.setAttribute('data-variant-media', 'true');
        thumbnail.setAttribute('data-variant-id', variantId);
        
        const thumbPlaceholder = document.createElement('div');
        thumbPlaceholder.className = 'product-media-placeholder';
        thumbnail.appendChild(thumbPlaceholder);
        newThumbnails.push(thumbnail);
      });

      newSlides.reverse().forEach((slide) => {
        this.swiperInstance.addSlide(0, slide);
      });

      this.swiperInstance.slideTo(0, 0);

      if (this.thumbnailsContainer) {
        this.thumbnailsContainer.innerHTML = '';
        newThumbnails.forEach(thumb => {
          this.thumbnailsContainer.appendChild(thumb);
        });
        this.thumbnails = this.container.querySelectorAll('[data-thumbnail]');
        this.bindThumbnailClicks();
      }

      this.preloadImages(images).then(() => {
        images.forEach((image, index) => {
          const slideIndex = newSlides.length - 1 - index;
          const slide = newSlides[slideIndex];
          const figure = slide.querySelector('figure');
          const placeholder = figure.querySelector('.product-media-placeholder');

          if (placeholder) {
            const img = document.createElement('img');
            img.src = image.src;
            img.alt = image.alt || '';
            img.className = 'cover';
            img.setAttribute('width', image.width);
            img.setAttribute('height', image.height);

            const widths = [375, 750, 928, 1108, 1500, 1856, 2216];
            const srcset = widths
              .map((width) => {
                const srcWithWidth = this.appendQueryToShopifyImageUrl(image.src, `${width}x`);
                return `${srcWithWidth} ${width}w`;
              })
              .join(', ');

            img.setAttribute('srcset', srcset);
            img.setAttribute('sizes', '(min-width: 1680px) 1108px, (min-width: 1024px) 66vw, 100vw');

            figure.replaceChild(img, placeholder);
            slide.classList.remove('loading');
          }

          const thumbnail = newThumbnails[index];
          const thumbPlaceholder = thumbnail.querySelector('.product-media-placeholder');
          if (thumbPlaceholder) {
            const thumbImg = document.createElement('img');
            thumbImg.src = image.src;
            thumbImg.alt = image.alt || '';
            thumbImg.className = 'cover';
            thumbImg.setAttribute('width', 200);
            thumbImg.setAttribute('height', 200);

            const thumbSrcset = [100, 200]
              .map((width) => {
                const srcWithWidth = this.appendQueryToShopifyImageUrl(image.src, `${width}x`);
                return `${srcWithWidth} ${width}w`;
              })
              .join(', ');

            thumbImg.setAttribute('srcset', thumbSrcset);
            thumbImg.setAttribute('sizes', '100px');

            thumbnail.replaceChild(thumbImg, thumbPlaceholder);
          }
        });
      });
    }

    this.thumbnails = this.container.querySelectorAll('[data-thumbnail]');
    this.updateThumbnails(variantId, true);

    if (this.swiperInstance) {
      this.swiperInstance.update();
    }
  }

  preloadImages(images) {
    return Promise.all(
      images.map((image) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(image);
          img.onerror = () => resolve(image);
          img.src = image.src;
        });
      })
    );
  }

  appendQueryToShopifyImageUrl(url, query) {
    if (!url) return url;
    const urlParts = url.split('?');
    const baseUrl = urlParts[0];
    const extension = baseUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i);
    
    if (!extension) return url;
    
    const urlWithoutExtension = baseUrl.slice(0, -extension[0].length);
    return `${urlWithoutExtension}_${query}${extension[0]}${urlParts[1] ? '?' + urlParts[1] : ''}`;
  }

  showDefaultImages(variantId) {
    if (!this.slider) return;

    const variantSlides = this.slider.querySelectorAll('[data-variant-media]');
    const defaultSlides = this.slider.querySelectorAll('[data-default-media]');

    variantSlides.forEach(slide => {
      slide.style.display = 'none';
    });

    defaultSlides.forEach(slide => {
      const slideVariants = slide.dataset.variants;
      
      if (slideVariants) {
        try {
          const variantArray = JSON.parse(slideVariants);
          if (variantArray.includes(Number(variantId))) {
            slide.style.display = '';
          } else {
            slide.style.display = 'none';
          }
        } catch (e) {
          slide.style.display = '';
        }
      } else {
        slide.style.display = '';
      }
    });

    this.thumbnails = this.container.querySelectorAll('[data-thumbnail]');
    this.updateThumbnails(variantId, false);

    if (this.swiperInstance) {
      this.swiperInstance.update();
      this.swiperInstance.slideTo(0);
    }
  }

  updateThumbnails(variantId, isVariantMedia) {
    if (!this.thumbnails.length) return;

    let firstVisibleIndex = -1;

    this.thumbnails.forEach((thumb, index) => {
      const thumbVariantMedia = thumb.dataset.variantMedia === 'true';
      const thumbVariantId = thumb.dataset.variantId;
      const thumbVariants = thumb.dataset.variants;

      if (isVariantMedia) {
        if (thumbVariantMedia && thumbVariantId === String(variantId)) {
          thumb.style.display = '';
          if (firstVisibleIndex === -1) firstVisibleIndex = index;
        } else {
          thumb.style.display = 'none';
        }
      } else {
        if (thumbVariantMedia) {
          thumb.style.display = 'none';
        } else if (thumbVariants) {
          try {
            const variantArray = JSON.parse(thumbVariants);
            if (variantArray.includes(Number(variantId))) {
              thumb.style.display = '';
              if (firstVisibleIndex === -1) firstVisibleIndex = index;
            } else {
              thumb.style.display = 'none';
            }
          } catch (e) {
            thumb.style.display = '';
            if (firstVisibleIndex === -1) firstVisibleIndex = index;
          }
        } else {
          thumb.style.display = '';
          if (firstVisibleIndex === -1) firstVisibleIndex = index;
        }
      }

      thumb.classList.remove('active');
    });

    if (firstVisibleIndex !== -1) {
      this.thumbnails[firstVisibleIndex].classList.add('active');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductMediaBlackFriday();
  });
} else {
  new ProductMediaBlackFriday();
}

